export default __webpack_public_path__ + "static/media/h-sites.e69df819.webp";